import { Image, Box, Heading, Text, Button, Center } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/img/logo.png'

export const NotFound = () => {
    return (
        <Box textAlign='center' py={{ base: 10, md: 24 }} px={6}>
            <Center mb={12}>
                <Image sx={{ width: 320 }} src={Logo} />
            </Center>
            <Heading
                display='inline-block'
                color={'violet.900'}
                size='2xl'
            >
                404
            </Heading>
            <Heading as='h2' size='2xl' >
                🙉
            </Heading>
            <Text fontSize='xl' mt={3} mb={2}>
                Página no encontrada
            </Text>
            <Text color={'gray.500'} mb={6}>
                La pagina a la que estás intentando acceder no existe
            </Text>

            <Button
                as={Link}
                to='/'
                size='lg'
                replace
                colorScheme='brand'
                variant='outline'>
                Volver al inicio
            </Button>
        </Box>
    );
}